module.exports = __webpack_public_path__ + "img/game-feature4.42e71dae.png";